(function($) {

  $(document).ready(function() {

    var $navbar = $(".navbar").height();
    var $adminbar = $("#wpadminbar").height();

    // Check if elements have height
    switch (true) {
      case isNaN($navbar):
        var $offset = $adminbar + 15;
        break;

      case isNaN($adminbar):
        var $offset = $navbar + 15;
        break;

      case isNaN($navbar) && isNaN($adminbar):
        var $offset = 15;
        break;

      default:
        var $offset = $navbar + $adminbar + 15;
    }

    // console.log($offset);
    stickybits(".sticky-element", {
      useStickyClasses: true,
      stickyBitStickyOffset: $offset
    });

  });

})(jQuery);